import React, { useEffect } from 'react'

import SupportSidebar from './components/SupportSidebar'
import { Sidebar, MainContent } from '../../layouts/components/Structure'
import { useState } from 'react'
import { GetAllFaq } from '../../store/ContentfulClient'
import Faqs from './components/Faqs'
import FurtherTrainingBorderBox from '../../components/FurtherTrainingBorderBox/FurtherTrainingBorderBox'

const Support = () => {
    const [faqItems, setFaqItems] = useState(null)

    useEffect(() => {
        const GetAllFaqItems = () => {
            GetAllFaq().then((items) => {
                setFaqItems(items)
            })
        }

        GetAllFaqItems()
    }, [])

    return (
        <>
            <Sidebar>
                <SupportSidebar />
            </Sidebar>
            <MainContent>
                <FurtherTrainingBorderBox />
                {faqItems && faqItems.length > 0 && (
                    <Faqs faqItems={faqItems} />
                )}
            </MainContent>
        </>
    )
}

export default Support
